"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.HEADER_AREA = void 0;
const HEADER_AREA = exports.HEADER_AREA = 'header-area';
